export default __webpack_public_path__ + "static/media/icon-baby.076a083a.svg";